<form class="flex flex-col w-full overflow-auto" [formGroup]="formulaireAutorisationInterventionForm" (ngSubmit)="onFormSubmit(true)">
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Nom de l'assuré</mat-label>
            <input type="text" matInput formControlName="nom_assure">
        </mat-form-field>
        <div class="w-full"></div>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4 mt-1">
        <mat-form-field class="w-full">
            <mat-label>Adresse de la propriété endommagée</mat-label>
            <input type="text" matInput formControlName="adresse_propriete_endommagee">
        </mat-form-field>
        <div class="w-full"></div>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <div class="w-full">
            Retient les services d’Urgex pour exécuter les travaux après un sinistre à l’adresse suivante :
        </div>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4 mt-1">
        <mat-form-field class="w-full">
            <mat-label>Adresse de domicile</mat-label>
            <input type="text" matInput formControlName="adresse_domicile">
        </mat-form-field>
        <div class="w-full"></div>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <div class="w-full">
            Je cède et transporte, jusqu’à concurrence du montant des travaux après sinistre effectués par Urgex, tous mes droits dans une police d’assurance dont le sinistre est :
        </div>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4 mt-1">
        <mat-form-field class="w-full">
            <mat-label>Compagnie d'assurance</mat-label>
            <input type="text" matInput formControlName="compagnie_assurance">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Numéro de police d'assurance</mat-label>
            <input type="text" matInput formControlName="no_police_assurance">
        </mat-form-field>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <div class="w-full">
            Et, j'autorise mes assureurs à payer la compagnie Urgex sur présentation de sa (ses) facture(s).
        </div>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Nom de l'expert en sinistre</mat-label>
            <input type="text" matInput formControlName="nom_expert_sinistre">
        </mat-form-field>
        <div class="w-full"></div>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Numéro de dossier d'intervention</mat-label>
            <input type="text" matInput formControlName="no_dossier_intervention">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Nom de la compagnie de l'expertise</mat-label>
            <input type="text" matInput formControlName="nom_compagnie_expertise">
        </mat-form-field>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4 mt-6">
        <div class="w-full">
            <label>Signature</label>
            <canvas #myCanvas id="myCanvas" width="664" height="314" style="border:1px solid #c3c3c3;" *ngIf="!formulaireIntervention || !formulaireIntervention.signature_client"></canvas>
            <button type="button" class="my-2" mat-flat-button [color]="'warn'" (click)="refreshCanvas()" id="resetSignatureClient" *ngIf="!formulaireIntervention || !formulaireIntervention.signature_client">Recommencer</button>
            <img [src]="STORAGE_URL + formulaireIntervention.signature_client" alt="" style="width:664px; height:314px" *ngIf="formulaireIntervention && formulaireIntervention.signature_client">
        </div>
    </div>
    <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4 mt-6">
        <mat-form-field class="w-full" *ngIf="!possedeSignature">
            <mat-label>Commentaire d'explication du manque de la signature</mat-label>
            <input type="text" matInput formControlName="commentaire_signature">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Courriel</mat-label>
            <input type="email" matInput formControlName="courriel_client">
        </mat-form-field>
        <div class="w-full" *ngIf="possedeSignature"></div>
    </div>
    <div class="pr-8 pl-8 pb-4 mt-6">
        <label class="w-full flex piece-jointe-table-row text-center" style="margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;">Formulaire d'autorisation d'intervention</label><br>
        <label for="formulaireAutorisationInterventionSigne" class="w-full flex piece-jointe-table-row text-center">
            <input class="hidden" id="formulaireAutorisationInterventionSigne" type="file" (change)="onFileSelected($event)" />
            <button type="button" class="mr-2" mat-flat-button [color]="'primary'" (click)="ajouterPdf()">Ajouter un pdf</button>
            <span class="mt-2">{{nomPdfSigne}}</span>
        </label>
    </div>
    <div class="flex items-center justify-between w-full border-t px-8 py-4">
        <div class="flex items-center">
            <div class="flex items-center mr-4" *ngIf="success || error">
                <ng-container *ngIf="success">
                    <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                    <span class="ml-2">Le formulaire d'autorisation d'intervention a été mis à jour</span>
                </ng-container>
                <ng-container *ngIf="error">
                    <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    <span class="ml-2">Erreur lors de l'enregistrement, réessayez!</span>
                </ng-container>
            </div>
            <button type="button" mat-flat-button [color]="'primary'" (click)="retourDossierIntervention()">Retour</button>
            <button type="button" (click)="callOnFormSubmit()" id="enregistrer" class="ml-1" mat-flat-button [color]="'primary'" [disabled]="fermer">Enregistrer</button>
            <button type="button" (click)="callOnFormSubmit()" id="fermer" class="ml-1" mat-flat-button *ngIf="formulaireIntervention" [color]="'primary'" [disabled]="(fermer || !possedeSignature)">Enregistrer et fermer le formulaire</button>
            <button (click)="download()" type="button" class="ml-1" mat-flat-button [color]="'primary'">Télécharger en PDF</button>
            <button (click)="openAsPdf()" type="button" class="ml-1" mat-flat-button [color]="'primary'">Ouvrir en PDF</button>
        </div>
    </div>
</form>
